import { render, staticRenderFns } from "./branchAccountReport.vue?vue&type=template&id=e2cbf482&"
import script from "./branchAccountReport.vue?vue&type=script&lang=js&"
export * from "./branchAccountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports